import React, { useState, useEffect, useContext } from 'react';
import { Container } from 'reactstrap';
import EventNewCard from './Card/EventNewCard';
import Amplify, { Auth } from 'aws-amplify';
import config from '../aws-exports';
import { UserContext } from '../components/UserContext';
import Lottie from 'react-lottie';
import { default as animationData } from '../assets/loader.json';
import { cx } from '@emotion/css';
import * as styles from './welcome/welcome.style';
import * as assignmentStyles from './assignments/assignments.style';
import eventHeroImg from '../assets/gen_images/eventicon.png';
import mathsImg from '../assets/gen_images/mathematics.png';

Amplify.configure(config);

function EventCatScreen(props) {
  const [events_category, set_events_category] = useState([]);
  const { user, setUser } = useContext(UserContext);
  const [loadedcategories, set_loadedcategories] = useState(false);

  useEffect(() => {
    getToken();
    document.title = 'Public Events | QuizWizard';
  }, []);

  const getToken = async () => {
    try {
      const userObj = await Auth.currentAuthenticatedUser();
      const res = await Auth.currentSession();
      const jwt = res.getAccessToken().getJwtToken();
      const username = userObj.username.includes("Google_") ? userObj.attributes['email'] : userObj.username;
      
      getuserDetails(username, jwt);
      getEventsfromDB(username, jwt);
    } catch (error) {
      console.error("Auth error:", error);
      Auth.signOut();
    }
  };

  const getEventsfromDB = async (username, jwt) => {
    try {
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: jwt },
        body: JSON.stringify({ username: username, eventtype: 'Event' }),
      };
      const response = await fetch(`https://api.quizwizard.net/quiz/eventcounts`, requestOptions);
      const data = await response.json();
      set_events_category(data);
      set_loadedcategories(true);
    } catch (error) {
      console.error("Error fetching event counts:", error);
      set_loadedcategories(true);
    }
  };

  const getuserDetails = async (username, jwt) => {
    try {
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: jwt },
        body: JSON.stringify({ username: username }),
      };
      const response = await fetch(`https://api.quizwizard.net/quiz/getuser`, requestOptions);
      const data = await response.json();
      setUser(data);
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: { preserveAspectRatio: 'xMidYMid slice' },
  };

  const filteredEvents = events_category.filter(event => 
    !event.category.toLowerCase().includes('algebra')
  );

  return (
    <div className={cx(styles.pageWrapper)}>


      <Container>
        <h2 className={cx(assignmentStyles.sectionHeading)} style={{ textAlign: 'center', marginBottom: '3rem', marginTop: '2.5rem' }}>
          Explore Categories
        </h2>

        {loadedcategories ? (
          filteredEvents.length > 0 ? (
            <div className={cx(assignmentStyles.challengeGrid)}>
              {filteredEvents.map((eventcategory) => (
                <EventNewCard
                  key={eventcategory.id}
                  title={eventcategory.category}
                  imgsrc={eventcategory.category.toLowerCase().includes('math') ? mathsImg : `https://api.quizwizard.net/assets/${encodeURIComponent(eventcategory.category)}.png`}
                  levels={[eventcategory.level]}
                  totalquestions={eventcategory.count}
                  event={{ ...eventcategory, category: eventcategory.category }}
                />
              ))}
            </div>
          ) : (
            <div style={{ 
              textAlign: 'center', 
              padding: '4rem 2rem', 
              background: 'rgba(0,0,0,0.02)', 
              borderRadius: '2rem',
              border: '2px dashed rgba(0,0,0,0.05)'
            }}>
              <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📅</div>
              <h3 style={{ fontWeight: '700', color: 'hsl(240, 15%, 15%)' }}>No Categories Available</h3>
              <p style={{ color: 'hsl(240, 5%, 40%)' }}>There are currently no event categories available. Please check back soon!</p>
            </div>
          )
        ) : (
          <div className="text-center py-5">
            <Lottie options={defaultOptions} height={200} width={200} />
            <p className="mt-3">Loading event categories...</p>
          </div>
        )}
      </Container>
    </div>
  );
}

export default EventCatScreen;
